module.exports = __webpack_public_path__ + "prod/20260929161836/img/purpose.cda92bb6.png";